
export interface SequenceCommand {
  type:string;
  data?:any;
}

export interface SequenceEntry {
  cmds:SequenceCommand[];
  duration:number;
}

export interface SequenceInterpreter {
  onStart():Promise<void>;
  onEnd():void;
  do(entry:SequenceEntry):Promise<void>;
};

export type Sequence = SequenceEntry[];

export class SequencePlayer {
  public get running():boolean { return this._running; }

  private _running:boolean = false;
  private _timeout:any = -1;
  private _resolve:()=>void;

  public constructor(private interpreter:SequenceInterpreter) {}
  
  public async play(sequence:Sequence):Promise<void> {
    this._running = true;
    
    await this.interpreter.onStart();

    for (const entry of sequence) {
      if (this._running) {
        await this.interpreter.do(entry);

        if (entry.duration != 0) {
          await this.sleep(entry.duration);
        }
      }
    }

    this.interpreter.onEnd();

    this._running = false;
  }

  private sleep(ms:number):Promise<void> {
    return new Promise<void>((resolve) => {
      this._resolve = resolve;
      this._timeout = setTimeout(resolve, ms)
    });
  }

  public stop():void {
    if (this._running) {
      this._running = false;
      if (this._timeout != -1) {
        clearTimeout(this._timeout);
        this._timeout = -1;
      }
      // forcefully resolve promise
      this._resolve();
    }
  }
}